import React from "react";
import "./ConfirmModal.css";

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, isDeleting, confirmLabel }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-card">
        <div className="confirm-modal-icon">?</div>
        <h3 className="confirm-modal-title">{title || "Are you sure?"}</h3>
        <p className="confirm-modal-message">
          {message || "Do you really want to delete this? This action cannot be undone."}
        </p>
        <div className="confirm-modal-actions">
          <button className="confirm-btn-cancel" onClick={onClose} disabled={isDeleting}>
            Cancel
          </button>
          <button className="confirm-btn-delete" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? (confirmLabel ? "Working..." : "Deleting...") : (confirmLabel || "Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
